import { isoLatin1Character } from '../../js/vue-flows/default-components/sb-validate/v2/character-mapping/iso-latin-1-character.js';
import { isoLatinExtendACharacter } from '../../js/vue-flows/default-components/sb-validate/v2/character-mapping/iso-latin-1-extend-a-character.js';
import allReplace from '@mixins/utils/all-replace';

export default string => {
    return allReplace(string, {
        ...isoLatin1Character,
        ...isoLatinExtendACharacter,
    });
};
